import CarLoanCalculatorContainer from "../../../components/pages/other/CarLoanCalculatorContainer";

const CarLoanCalculator = () => {
  return <CarLoanCalculatorContainer />;
};

export default CarLoanCalculator;